import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { SvgIcon } from '@progress/kendo-react-common';
import dayjs from 'dayjs';
import { openWindow } from '../../../services/openWindow';
import { ILink } from '../../../types/link';
import { VehicleValue } from '../Vehicles';
import { formatNumber } from '@progress/kendo-intl';
import { DriverResponseDialogPayload } from '../DriverResponseDialog';
import { clockIcon, dollarIcon } from '@progress/kendo-svg-icons';
import { dateFormatter } from 'utils/utils';

// Rate = Linehaul + Accessorial
export default function vehicleOfferCell(
    distance: number,
    rate: number,
    fuel: number,
    bonus: number,
    cancel: (vehicleID: number) => void,
    offer: (vehicle: VehicleValue, allInRate: number, linehaul: number, fuel: number, deadhead: number) => void,
    openDriverResponseDialog: (payload: DriverResponseDialogPayload) => void
) {
    return class extends React.Component<GridCustomCellProps> {
        render() {
            const vehicle = this.props.dataItem as VehicleValue;

            if (vehicle.QuoteOfferStatus == 0) {
                return <td {...this.props.tdProps}><button className="btn btn-sm btn-info" onClick={(e) => {
                    if (e.detail > 1) {
                        return;
                    }
                    cancel(vehicle.VehicleID);
                }}>
                    Cancel
                </button></td>
            }

            if (vehicle.QuoteOfferStatus == 1) {
                return <td {...this.props.tdProps}><button
                    className="btn btn-sm btn-danger"
                    title={vehicle.DeclineReason}
                    onClick={(e) => {
                        e.preventDefault();
                        openWindow(`/Assets/Vehicle/${vehicle.VehicleID}/Turndowns`);
                    }}
                >
                    Declined
                </button></td>
            }

            if (vehicle.QuoteOfferStatus == 3) {
                return <td {...this.props.tdProps}><button className="btn btn-sm btn-warning" onClick={(e) => {
                    e.preventDefault();
                    openWindow(`/Assets/Vehicle/${vehicle.VehicleID}/Turndowns`);
                }}>
                    Expired
                </button></td>
            }

            if (vehicle.QuoteOfferStatus == 2) {
                const allInRate = vehicle.QuoteOfferAlternativeAllInRate || vehicle.QuoteOfferAllInRate;
                const payload: DriverResponseDialogPayload = {
                    allInRate,
                    originalAllInRate: vehicle.QuoteOfferAllInRate,
                    alternativeAllInRate: vehicle.QuoteOfferAlternativeAllInRate,
                    alternativePickup: vehicle.QuoteOfferAlternativePickup,
                    alternativeDelivery: vehicle.QuoteOfferAlternativeDelivery,
                };

                return <td {...this.props.tdProps}>
                    <button
                        className="btn btn-sm btn-success"
                        onClick={() => vehicle.IsAlternativeOffer && openDriverResponseDialog(payload)}
                    >
                        {!vehicle.IsAlternativeOffer && formatNumber(allInRate, "c")}
                        <span className={vehicle.IsAlternativeOffer ? 'd-inline-flex align-items-center' : undefined}>
                            {vehicle.QuoteOfferAlternativeAllInRate && (
                                <span title={`Alt Rate: ${formatNumber(vehicle.QuoteOfferAlternativeAllInRate, 'c2')}`}>
                                    <SvgIcon icon={dollarIcon} color="#FFC107" />
                                </span>
                            )}
                            {vehicle.QuoteOfferAlternativePickup && (
                                <span title={`Alt Pickup: ${dateFormatter(vehicle.QuoteOfferAlternativePickup)}`}>
                                    <SvgIcon icon={clockIcon} color="#0DCAf0" />
                                </span>
                            )}
                            {vehicle.QuoteOfferAlternativeDelivery && (
                                <span
                                    style={{ paddingLeft: vehicle.QuoteOfferAlternativePickup ? 4 : 0 }}
                                    title={`Alt Delivery: ${dateFormatter(vehicle.QuoteOfferAlternativeDelivery)}`}
                                >
                                    <SvgIcon icon={clockIcon} color="#FFC107" />
                                </span>
                            )}
                        </span>
                    </button>
                </td>
            }

            if (vehicle.Links.filter((x: ILink) => x.Name === "Offer").length > 0) {
                const fuelAmount = fuel * vehicle.FuelPercentage;
                const linehaulAmount = (rate * vehicle.LinehaulPercentage) + (distance * vehicle.LinehaulRPM);
                const minLinehaulAmount = distance * this.props.dataItem.LinehaulRPMMin;
                const deadheadAmount = Math.max(this.props.dataItem.Distance - this.props.dataItem.FreeDeadheadMiles, 0) * this.props.dataItem.DeadheadRPM;
                const payAmount = vehicle.QuoteOfferAllInRate ? vehicle.QuoteOfferAllInRate : Math.max(linehaulAmount, minLinehaulAmount) + fuelAmount + deadheadAmount + bonus;
                return <td {...this.props.tdProps}><button className="btn btn-sm btn-primary" onClick={(e) => {
                    if (e.detail > 1) {
                        return;
                    }
                    if (vehicle.IsReservedByMe && !window.confirm("The reservation you have for this vehicle will be released if they decline.")) {
                        return;
                    }
                    if (vehicle.IsAgainstDestination && !window.confirm(`${vehicle.VehicleNumber} would like to be in ${vehicle.Destination.Location} by ${dayjs.utc(vehicle.Destination.DateTime).tz("America/New_York").format("M/D HH:mm")}, still offer?`)) {
                        return;
                    }
                    if (vehicle.HoursOfService && !vehicle.HasHoursRemaining && !window.confirm("Driver may not be have enough hours of service to complete this trip, still offer?")) {
                        return;
                    }

                    offer(vehicle, payAmount, linehaulAmount, fuelAmount, deadheadAmount);
                }}>
                    Offer
                </button></td>
            }

            return <td {...this.props.tdProps}>
                {vehicle.Links.find((x: ILink) => x.Name === 'DriverProfile') && <button className="btn btn-sm btn-secondary" style={{ opacity: .65 }} onClick={() => {
                openWindow(vehicle.Links.find((x: ILink) => x.Name === 'DriverProfile').Link);
            }}>
                Offer
            </button>}
            </td>
        }

        public shouldComponentUpdate(nextProps: GridCustomCellProps) {
            return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
        }
    };
}
